export default __webpack_public_path__ + "static/media/GaugeImg1.76cdf54e.jpg";